import { useMutation, useQueryClient } from 'react-query';

import client from 'client';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';

const declineMeeting = async ({ eventId, meetingId }: { eventId: number; meetingId: string }) => {
    const response = await client().post<void>(
        `/api/v2/meetings/events/${eventId}/scheduledMeetings/${meetingId}/decline`
    );
    return response.data;
};

const useDeclineMeeting = () => {
    const queryClient = useQueryClient();
    return useMutation(declineMeeting, {
        onMutate: () => {
            queryClient.cancelQueries(MeetingsHttpKey.Meetings);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsGroups);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(MeetingsHttpKey.Meetings);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsGroups);
        },
        useErrorBoundary: true,
    });
};

export default useDeclineMeeting;
